import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterConstants, AppConstants, DefaultValues, AppDetails } from 'src/app/Models/app-data';
import { FormGroup, FormBuilder, Validators, FormGroupDirective, FormControl, FormArray } from '@angular/forms';
import { FormsService } from 'src/app/Services/forms-service/forms.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/Services/alert-service/alert-service.service';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';

@Component({
    selector: 'app-stocktake-form',
    templateUrl: './stocktake-form.component.html',
    styleUrls: ['./stocktake-form.component.scss']
})
export class StocktakeFormComponent implements OnInit {
    routerConstants = RouterConstants;
    appConstants = AppConstants;
    url: any;
    stocktakeForm: FormGroup;
    allUserDetails: any[];
    userFilter: FormControl = new FormControl();
    public filteredUsers: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    protected _onDestroy = new Subject<void>();

    isFormReady: boolean = false;
    isSubmitClicked: boolean = false;
    defaultValues: DefaultValues = new DefaultValues();
    appDetails = AppDetails;
    showCredentialModal = false;
    isValid = false;

    @ViewChild("SignaturePad", { static: false }) SignaturePad: SignaturePad;


    signaturePadOptions: Object = {
        'canvasWidth': 250,
        'canvasHeight': 200,
        'backgroundColor': 'white',
        'minWidth': 0.5
    };

    constructor(
        private formBuilder: FormBuilder,
        private formDataSrv: FormsService,
        private router: Router,
        private alertSrv: AlertService, private route: ActivatedRoute) { }

    async ngOnInit() {
        this.isSubmitClicked = false;
        this.userFilter.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterUsers();
            });
        this.url = this.route.snapshot.data['url'];
        let dateTime = new Date()
        this.stocktakeForm = this.formBuilder.group({
            UserType: ['', Validators.required],
            User: [[], Validators.required],
            UserName: ['', Validators.required],
            Organization: [''],
            PrintName: ['', Validators.required],
            //Signature: ['', Validators.required],
            Date: [dateTime, Validators.required],
            IsAcknowledge: [false, Validators.required],
            modelDetails: this.formBuilder.array([]),
            submissionType: this.url

        });
        this.stocktakeForm.get('UserType').setValue(this.appConstants.other);
        this.stocktakeForm.get('UserType').disable();
        this.onUserTypeChange();
        this.addNewModel()        
        await this.getDefaultValues();
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;

    }

    async getDefaultValues() {
        await this.formDataSrv.getDefaultValues().toPromise().then(res => {
            this.defaultValues = JSON.parse(res);
            this.isFormReady = true;
        }).catch(err => console.log(err.error));
    }

    private filterUsers() {
        if (!this.allUserDetails) {
            return;
        }
        // get the search keyword
        let search = this.userFilter.value;
        if (!search) {
            this.filteredUsers.next(this.allUserDetails.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.filteredUsers.next(
            this.allUserDetails.filter(ctc =>
                ctc["UserName"].toLowerCase().indexOf(search) !== -1 ||
                ctc["DomainUserID"].toLowerCase().indexOf(search) !== -1
            )
        );
    }

    getAllActiveUsersList() {

        this.formDataSrv.getAllActiveUsersList().toPromise()
            .then(res => {

                var resData = JSON.parse(res);
                this.allUserDetails = resData;
                this.filteredUsers.next(this.allUserDetails);
            })
            .catch(err => {
                console.log(err.error);
            });
    }
    handleCredentials({ username, password }: { username: string; password: string }) {
        this.formDataSrv.validateCredentials(username, password).subscribe(res => {
            if (res.valid) {
                this.isValid = true;
                this.showCredentialModal = false;
                this.stocktakeForm.get('UserType').setValue(this.appConstants.hmca);
                this.getAllActiveUsersList();
                this.stocktakeForm.get('UserName').clearValidators();
                this.stocktakeForm.get('Organization').setValue('');
                this.stocktakeForm.get('Organization').clearValidators();
                this.stocktakeForm.get('User').setValidators(Validators.required);
            } else {
                alert('Invalid credentials');
                this.isValid = false;
                this.stocktakeForm.get('UserType').setValue('');
                this.stocktakeForm.get('UserType').updateValueAndValidity();
            }
            //this.showCredentialModal = false;
        }, error => {
            alert('Error validating credentials');
            this.isValid = false;
            this.stocktakeForm.get('UserType').setValue('');
            this.stocktakeForm.get('UserType').updateValueAndValidity();
            //this.showCredentialModal = false;
        });
    }

    clearRadioSelection() {
        this.stocktakeForm.get('UserType').setValue('');
        this.stocktakeForm.get('UserType').updateValueAndValidity();
        this.showCredentialModal = false;
    }
    onUserTypeChange() {
        let val = this.stocktakeForm.get('UserType').value;
        this.stocktakeForm.get('PrintName').setValue('');
        this.stocktakeForm.get('PrintName').updateValueAndValidity();
        this.stocktakeForm.get('UserName').setValue('');
        if (val == this.appConstants.hmca) {
            this.getAllActiveUsersList();
            this.stocktakeForm.get('UserName').clearValidators();
            this.stocktakeForm.get('Organization').setValue('');
            this.stocktakeForm.get('Organization').clearValidators();
            this.stocktakeForm.get('User').setValidators(Validators.required);
            //this.showCredentialModal = this.isValid ? false : true;
        }
        else {
            this.stocktakeForm.get('User').setValue(null);
            this.stocktakeForm.get('User').clearValidators();

            this.stocktakeForm.get('UserName').setValidators(Validators.required);
            this.stocktakeForm.get('Organization').setValidators(Validators.required);
        }
        this.stocktakeForm.get('User').updateValueAndValidity();
        this.stocktakeForm.get('UserName').updateValueAndValidity();
        this.stocktakeForm.get('Organization').updateValueAndValidity();
    }

    setUserName() {
        this.stocktakeForm.get('UserName').setValue(this.stocktakeForm.get('User').value.UserName);
        this.stocktakeForm.get('PrintName').setValue(this.stocktakeForm.get('User').value.UserName);
    }
    setPrintName() {
        this.stocktakeForm.get('PrintName').setValue(this.stocktakeForm.get('UserName').value);
    }

    async validateRegoNumber(regoNumber, index) {
        
        let model = this.stocktakeForm.get('modelDetails') as FormArray;
        let foundIndex = model.value.findIndex(record => record.RegoNumber === regoNumber);
        if ( foundIndex != index && foundIndex > -1 ) {
            this.alertSrv.showError("Error", "Rego number - " + regoNumber + " already exist!!", "Ok").then(async decision => {
                model.at(index).get('RegoNumber').setValue('');
            });
        }
        else {
            await this.formDataSrv.validateRego(regoNumber).toPromise()
                .then(res => {
                    let resData = JSON.parse(res)[0];
                    if (!resData.IsRegoValidated) {
                        this.alertSrv.getUserConfirmation("Rego number - " + regoNumber + " not found!!", "Are you sure you want to continue?", "Yes", "No").then(async decision => {
                            if (!decision.value) {
                                model.at(index).get('RegoNumber').setValue('');
                            }
                        });
                    }
                    else
                        this.isSubmitClicked = false;

                    model.at(index).get('IsRegoValidated').setValue(resData.IsRegoValidated);
                    model.at(index).get('DSN').setValue(resData.DSN);
                    model.at(index).get('VIN').setValue(resData.VIN);
                    model.at(index).get('Model').setValue(resData.Model);
                });
        }
    }

    async onSubmit(form: FormGroup, formDirective: FormGroupDirective) {
        this.isSubmitClicked = true;
        if (form.valid) {
            this.submitStoketake(form, formDirective);
            //this.alertSrv.getUserConfirmation("Are you sure?", "You cannot revert the process.", "Yes", "No").then(async decision => {
            //    if (decision.value)
            //        await
            //    //else
            //    //    this.isSubmitClicked = false
            //})
        }
    }

    async submitStoketake(form: FormGroup, formDirective: FormGroupDirective) {
        this.formDataSrv.submitForm(form.getRawValue()).toPromise().then(res => {
            this.alertSrv.showSuccess(
             (this.url == this.routerConstants.Stocktake ? "Stocktake" : "FBT Declaration") + " successfully submitted.", "", "Ok").then(decision => {
                //this.resetForm(formDirective);
                //this.clearCanvas();
                this.ngOnInit();

                //this.router.navigateByUrl("/" + this.routerConstants.Stocktake)
            })
        }).catch(error => { console.log(error.error); });

    }

    resetForm(formDirective: FormGroupDirective) {
        this.isSubmitClicked = false;
        formDirective.reset();
        this.clearCanvas();

        let dateTime = new Date();
        this.stocktakeForm.patchValue({
            Date: dateTime
        });

    }

    onSignatureComplete() {
        var sign = this.SignaturePad.toDataURL();
        this.stocktakeForm.get('Signature').setValue(sign);
    }

    clearCanvas() {
        this.SignaturePad.clear();
        this.stocktakeForm.get('Signature').reset();
    }

    addNewModel() {
        this.isSubmitClicked = false;
        const model = this.stocktakeForm.get('modelDetails') as FormArray;
        model.push(this.formBuilder.group({
            Model: ['', Validators.required],
            DSN: [''],
            VIN: [''],
            RegoNumber: ['', Validators.required],
            IsRegoValidated: [false],
            KM: [0, [Validators.required, Validators.min(1)]],
        }))
    }
    deleteModelDetails(index) {
        this.isSubmitClicked = false;
        let modelList = this.stocktakeForm.get('modelDetails') as FormArray;
        modelList.removeAt(index);
    }
}